import { Board, Shipment } from "../../../reducers/uploadedBoard";
import {
  IconContainer,
  MessageContainer,
  Warnings,
  WarningsContainer,
} from "./BoardAlertsStyles";
import Icon from "../../common/Icon";
import Link from "next/link";
import LoadingIcon from "../../common/LoadingIcon";

function ConsignmentAlerts({ shipments }: { shipments: Shipment[] | null }) {
  if (shipments === null) {
    return null;
  }
  if (shipments[0]!.has_consigned_parts) {
    return (
      <Warnings>
        <Icon
          src="/icons/warn.svg"
          alt="Warning"
          styleProps={{ margin: "0 .25rem" }}
        />
        <div>
          This order may be delayed if consignment part(s) are not received with
          sufficient time for assembly. A deadline will be included in your
          order confirmation email.
        </div>
      </Warnings>
    );
  }
}

function UpdatingWarningIcon({ isUpdating }: { isUpdating: boolean }) {
  return (
    <IconContainer>
      {isUpdating ? (
        <LoadingIcon />
      ) : (
        <Icon src="/icons/warn.svg" alt="Warning" />
      )}
    </IconContainer>
  );
}

function QuoteAlerts({
  board,
  isUpdating,
}: {
  board: Board;
  isUpdating: boolean;
}) {
  if (board.quote.total === null && board.quote.estimated_total === null) {
    // If the quote was never calculated
    return null;
  }
  if (board.quote.total === null) {
    const quoteAlertMessage = board.quote.requested_custom_quote
      ? "A FlashPCB engineer will look at your board and provide a finalized price."
      : "The items listed above must be resolved to get an instant quote and checkout. Otherwise, you can request a custom quote and a FlashPCB engineer will get back to you.";
    return (
      <>
        {board.quote.issues.map((issue) => {
          return (
            <Warnings key={issue.message}>
              <UpdatingWarningIcon isUpdating={isUpdating} />
              <MessageContainer>{issue.message}</MessageContainer>
            </Warnings>
          );
        })}
        <Warnings>
          <UpdatingWarningIcon isUpdating={isUpdating} />
          <MessageContainer>
            {quoteAlertMessage} See{" "}
            <Link
              href={`/docs/uploading-your-board#getting-a-quote`}
              target="_blank"
            >
              our docs
            </Link>{" "}
            for more details.
          </MessageContainer>
        </Warnings>
      </>
    );
  }
  return null;
}

export function ProjectDetailsBoardAlerts({
  board,
  isUpdating,
}: {
  board: Board;
  isUpdating: boolean;
}) {
  return (
    <WarningsContainer>
      <QuoteAlerts board={board} isUpdating={isUpdating} />
    </WarningsContainer>
  );
}

export default function BoardCardAlerts({
  board,
  shipments,
  isUpdating,
}: {
  board: Board;
  shipments: Shipment[] | null;
  isUpdating: boolean;
}) {
  return (
    <WarningsContainer>
      <QuoteAlerts board={board} isUpdating={isUpdating} />
      <ConsignmentAlerts shipments={shipments} />
    </WarningsContainer>
  );
}
